import React from 'react'
import { Form, Button, Input, message } from 'antd';
// import ImgCrop from 'antd-img-crop';
import { connect } from 'dva'
import { withRouter } from 'react-router-dom'
import style from './index.less'
import SelectBirthdayCard from '../components/index'
import PreviewCom from '../components/preview'

const childRef = React.createRef()
const { TextArea } = Input;
@connect(({ getPushRuless }) => ({
  ...getPushRuless,
}))
@withRouter
class BirthdayPush extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lengthper: 0,
      lengthcoll: 0,
      contentC: '',
      schoolN: ''
    }
  }

  componentDidMount () {
    this.updatedate()
    const { dispatch } = this.props
    return dispatch({
      type: 'getPushRuless/ismanager'
    })
  }

  // 获取卡片列表
  getdata () {
    const { dispatch } = this.props;
    return dispatch({
      type: 'getPushRuless/getBackList',
      payload: {
        cardType: 'employee'
      }
    })
  }

  handleSubmit = e => {
    const { manager, form, dispatch, selectCard } = this.props
    const { result } = manager || {}
    if (result) {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          const { coverInfoper, pushwordper, schoolname } = values
          const { id, url, urlTow } = coverInfoper
          dispatch({
            type: 'getPushRuless/subCardBasic',
            payload: {
              backgroundId: id,
              cardType: 'employee',
              content: pushwordper,
              id: (selectCard || {}).id || null,
              signName: schoolname,
              bgOneUrl: url,
              bgTwoUrl: urlTow
            }
          })
        } else {
          message.error("必填项不能为空")
        }
      });
    } else {
      message.error("对不起，您还没有该权限，请联系管理员开通！")
    }

  };

  onCoverListChange = (coverList) => {
    const { dispatch } = this.props;
    // 保存选中通知类型和对应的封面列表
    dispatch({
      type: 'safeClockCreate/save',
      payload: {
        coverList,
      },
    });
  }

  // 保存表单数据
  handleFormDataChange = payload => {
    const { dispatch, form } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({ ...payload });
    dispatch({
      type: "safeClockCreate/saveFormData",
      payload: { ...payload }
    });
  };

  // 落款改变
  onChangeColleagueText = e => {
    this.setState({
      lengthcoll: e.target.value.length,
      schoolN: e.target.value
    })
  };

  // 祝福语改变
  onChangePersonText = e => {
    this.setState({
      lengthper: e.target.value.length,
      contentC: e.target.value,
    })
  }

  // 获取已选中封面
  getSelectCard = () => {
    const { dispatch } = this.props;
    return dispatch({
      type: 'getPushRuless/getSelectCard',
      payload: {
        cardType: 'employee'
      }
    })
  }

  preview = (item) => {
    const { dispatch } = this.props
    dispatch({
      type: 'getPushRuless/upDate',
      payload: {
        show: item.show,
        data: item.data
      }
    })
  }

  async updatedate () {
    await this.getdata()
    await this.getSelectCard()
    const { selectCard } = this.props
    const { content, signName } = selectCard || {}
    this.setState({
      lengthper: content?.length,
      lengthcoll: signName?.length,
      contentC: content,
      schoolN: signName
    })
  }



  render () {
    const { form, backlist, selectCard } = this.props
    const { getFieldDecorator } = form;
    const { lengthper, lengthcoll, contentC, schoolN } = this.state
    const selectCoverProps = {
      backlist,
      form,
      selectCard,
      onCoverListChange: this.onCoverListChange,
      handleOk: this.handleFormDataChange,
      preview: this.preview,
      onRef: childRef
    };
    const { content, signName } = selectCard || {}
    return (
      <div className={style.poster}>
        <div className={style.poster_root}>
          <div className={style.poster_header}>
            推送规则
          </div>
          <Form
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 14,
            }}
            onSubmit={this.handleSubmit}
            layout="horizontal"
            labelAlign="right"
          >
            <Form.Item
              label="贺卡背景"
              colon
            >
              {getFieldDecorator("coverInfoper", {
                initialValue: '',
                valuePropName: 'coverInfoper',
                rules: [
                  {
                    required: true,
                  },
                ]
              })
                (<SelectBirthdayCard {...selectCoverProps} />)
              }
            </Form.Item>
            <Form.Item
              label="祝福语"
              colon
            >
              {
                getFieldDecorator("pushwordper", {
                  initialValue: (content || ''),
                  rules: [
                    {
                      required: true,
                      message: "必填项不能为空"
                    },
                  ]
                })(
                  <TextArea maxLength={55} placeholder="请输入祝福语！" style={{ wordBreak: "break-all", wordWrap: "break-word" }} onChange={this.onChangePersonText} />
                )
              }
              <div className={style.limit_word} style={{ color: lengthper >= 55 ? "red" : "#000000" }}>{lengthper < 55 ? lengthper : 55}/55</div>
            </Form.Item>
            <Form.Item
              label="落款"
              colon
            >
              {
                getFieldDecorator("schoolname", {
                  initialValue: (signName || ''),
                  rules: [
                    {
                      required: true,
                      message: "必填项不能为空"
                    },
                  ]
                })(
                  <Input maxLength={18} placeholder="请输入落款！" style={{ wordBreak: "break-all", wordWrap: "break-word", height: '32px' }} onChange={this.onChangeColleagueText} />
                )
              }
              <div className={style.limit_word} style={{ color: lengthcoll >= 18 ? "red" : "#000000" }}>{lengthcoll < 18 ? lengthcoll : 18}/18</div>
            </Form.Item>
          </Form>
        </div>

        <div className={style.footer}>
          <Button onClick={() => { childRef.current.handelPreview() }}>预览</Button>
          <Button type="primary" htmlType="submit" onClick={this.handleSubmit}>保存</Button>
        </div>
        <PreviewCom content={contentC} schoolN={schoolN} />
      </div>

    )
  }

}


const BirthdayPushWrappers = Form.create({ name: 'validate_other' })(BirthdayPush);

export default BirthdayPushWrappers;